<div class="d-inline-block"
     ngbDropdown>
  <button type="button"
          class="btn btn-link text-primary p-0 dropdown-toggle"
          ngbDropdownToggle
          data-testid="device-health-state-filter">
    {{ selectionLabel() }}
  </button>
  <div ngbDropdownMenu>
    @for (option of options; track option.type) {
      <button type="button"
              class="dropdown-item d-flex align-items-center gap-2"
              role="menuitemradio"
              [attr.aria-checked]="isSelected(option.type)"
              (click)="select(option.type)">
        <span class="flex-grow-1">{{ option.title }}</span>
        @if (isSelected(option.type)) {
          <span aria-hidden="true">✓</span>
        }
      </button>
    }
  </div>
</div>